// import { push } from 'react-router-redux'
import { receiveStructure } from './structures'
import { receiveProject } from './projects'
import { push } from 'react-router-redux';

export const SEND_FILE = 'SEND_FILE'
export const SEND_FILE_REQUESTED = 'SEND_FILE_REQUESTED'
export const SEND_FILE_COMPLETED = 'SEND_FILE_COMPLETED'
export const SEND_FILE_SUCCESSFULL = 'SEND_FILE_SUCCESSFULL'
export const SEND_FILE_FAILED = 'SEND_FILE_FAILED'

const initialState = {
  files: [],
  isSendingFile: false,
  isSendingCompleted: false,
  isSendingWasSucessfull: true,
  errors: []
}

export default (state = initialState, action) => {

  switch (action.type) {

    case SEND_FILE_REQUESTED:
      return {
        ...state,
        isSendingFile: true
      }

    case SEND_FILE:
      const { files } = action
      return {
        ...state,
        files: files
      }

    case SEND_FILE_COMPLETED:
      return {
        ...state,
        isSendingFile: false,
        isSendingCompleted: true
      }

    case SEND_FILE_SUCCESSFULL:
      return {
        ...state,
        isSendingWasSucessfull: true
      }

    case SEND_FILE_FAILED:
      const { errors } = action
      return {
        ...state,
        isSendingWasSucessfull: false,
        errors: errors
      }

    default:
      return state
  }
}

export const send = (files, ...param) => dispatch => {
  const id = param[1].currentTarget.dataset.id
  //const file = files[0]
  const data = new FormData();
  files.forEach(file => data.append('files', file))
  dispatch({
    type: SEND_FILE_REQUESTED
  })
  const url = id ? `/api/projects/${id}/uploadCif` : '/api/media/upload';
  fetch(url, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('id_token')
    },
    method: 'POST',
    body: data
  }).then(response => response.json().then(project => ({ project, response })))
  .then(({ project, response }) =>  {
    dispatch({
      type: SEND_FILE_COMPLETED
    });
    if (!response.ok) {
      // If there was a problem, we want to
      // dispatch the error condition
      dispatch({
        type: SEND_FILE_FAILED,
        errors: project.message
      });
      return Promise.reject(project)
    } else {
      // If login was successful, set the token in local storage
      // Dispatch the success action
      dispatch({
        type: SEND_FILE_SUCCESSFULL
      });
      dispatch(receiveProject(project));
      project.structures.forEach((structure) =>
        dispatch(receiveStructure(structure))
      )

      dispatch(push(`/projects/${project._id}`))
    }
  }).catch(err => console.log("Error: ", err))
}



// WEBPACK FOOTER //
// ./src/modules/media.js